import { Image } from 'react-native';

import LoadingAnimation from 'components/loading-animation';

import { IVenmoButton } from './types';
import { useBraintree } from './use-braintree.web';
import { StyledButton } from './venmo-button.styled';

const venmoLogo = require('../../../../ucl/themes/shared/icons/VenmoLogo.png');

const VenmoButton: React.FC<IVenmoButton> = ({ onResult, onError, showLoading }: IVenmoButton) => {
  const { isLoading, loadVenmoUI } = useBraintree({
    onResult,
    onError,
  });

  return (
    <>
      {isLoading || showLoading ? (
        <LoadingAnimation />
      ) : (
        <StyledButton
          onPress={() => loadVenmoUI()}
          fullWidth
          rightIcon={
            <Image
              style={{ width: 100, height: 40, ...({ pointerEvents: 'none' } as any) }}
              resizeMode="contain"
              source={venmoLogo}
            />
          }
        />
      )}
    </>
  );
};

export default VenmoButton;
